import React from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { PopularVideos } from './components/PopularVideos';
import { ForWho } from './components/ForWho';
import { WhySubscribe } from './components/WhySubscribe';
import { Instagram } from './components/Instagram';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background text-white selection:bg-amber-500/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Features data-id="element-2" />
      <PopularVideos data-id="element-3" />
      <ForWho data-id="element-4" />
      <WhySubscribe data-id="element-5" />
      <Instagram data-id="element-6" />
      <FAQ data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}